import { BaseEntity } from "../../../../shared/models/ApiModels"
import * as Yup from 'yup'

export interface IVehicleOwnerModel extends BaseEntity{
  id: string
  name: string
}

export const initialVehicleOwner: IVehicleOwnerModel = {
  id: '',
  name: '',
}

export const validationVehicleOwner = Yup.object().shape({
  name: Yup.string().required('Grup adı zorunludur'),
})


